module.exports = __webpack_public_path__ + "assets/img/ko-3d0376a0.png";